var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOwnerApp2FaExpired(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 54l-4.777 13.503L13 56l-1.12 12.241L6 62l2.518 16h20.72L22 54z",
    fill: "#28BF9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.193 78l1.647-3.276C57.518 69.398 62.945 66 68.775 66c3.303 0 6.476 1.097 9.03 3.122L89.001 78",
    fill: "#192C55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.05 72l-.1 6h-54l.1-6H24l4.5-14 17.969-3L63.5 58l4.18 13-.887.352L68 72h5.05-.001zM59 44l-4.5-14-6.5-3-10.5 3L33 44l13.916 10L59 44z",
    fill: "#C2E2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 30h-17L42 16h8l4.5 14zM59 44H33l-4.5 14h35L59 44z",
    fill: "#116DFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91 78v1H5v-1h86zm-23.32-7H46v1h22l-.32-1z",
    fill: "#192C55"
  })));
}

export default "data:image/svg+xml,%3csvg width='96' height='96' viewBox='0 0 96 96' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M22 54L17.223 67.503L13 56L11.88 68.241L6 62L8.518 78H10.987H13.509H21.076H29.238L22 54Z' fill='%2328BF9A'/%3e %3cpath d='M53.193 78L54.84 74.724C57.518 69.398 62.945 66 68.775 66C72.078 66 75.251 67.097 77.805 69.122L89.001 78' fill='%23192C55'/%3e %3cpath d='M73.05 72L72.9499 78H18.95L19.0499 72H24L28.5 58L46.469 55L63.5 58L67.68 71L66.7929 71.352L68.0009 72H73.051H73.05ZM59 44L54.5 30L48 27L37.5 30L33 44L46.916 54L59 44Z' fill='%23C2E2FF'/%3e %3cpath d='M54.5 30H37.5L42 16H50L54.5 30ZM59 44H33L28.5 58H63.5L59 44Z' fill='%23116DFF'/%3e %3cpath d='M91 78V79H5V78H91ZM67.68 71H46V72H68L67.68 71Z' fill='%23192C55'/%3e %3c/svg%3e";
export { SvgOwnerApp2FaExpired as ReactComponent };